module.exports = __webpack_public_path__ + "img/logo.446af178.png";